import { render } from "./BackerCenterLayout.vue?vue&type=template&id=47c2a75c"
import script from "./BackerCenterLayout.vue?vue&type=script&lang=js"
export * from "./BackerCenterLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__